import { withSnackbarsContext } from '@stratumn/atomic';

import to from 'await-to-js';
import { Button } from 'components/ui';
import { StepperContext } from 'components/ui/stepper';
import PropType from 'prop-types';
import { toast } from 'sonner';

export const Submit = ({ isValid, onSubmit, ...props }) => (
  <StepperContext.Consumer>
    {({ finalStep }) => {
      const onClick = async () => {
        const [err, result] = await to(onSubmit());
        if (err) toast.error(err.message);
        else finalStep(result);
      };

      return (
        <Button
          data-testid="submit"
          disabled={!isValid}
          onClick={onClick}
          {...props}
        >
          Submit
        </Button>
      );
    }}
  </StepperContext.Consumer>
);

Submit.propTypes = {
  isValid: PropType.bool.isRequired,
  onSubmit: PropType.func.isRequired
};

export default withSnackbarsContext(Submit);
